import styled from 'styled-components';

import { cBC44FF } from '#/colors';

import {
  TERMS_OF_SERVICE_URL,
  ABOUT_RESTRICTED_PERSONS_URL,
} from '#/routes-external';

import { Translation, useTranslation } from '#/features/localization/utils';

export default function LegalDisclaimer() {
  const { t } = useTranslation();

  return (
    <Translation
      t={t}
      i18nKey="By connecting a wallet, you agree to <1>Paradex Terms of Service</1> and represent and warrant to Paradex that you are not a <2>Restricted Person</2>."
      components={{
        1: <ExternalLink href={TERMS_OF_SERVICE_URL} />,
        2: <ExternalLink href={ABOUT_RESTRICTED_PERSONS_URL} />,
      }}
    />
  );
}

const ExternalLink = styled.a.attrs({
  target: '_blank',
  rel: 'noopener',
})`
  color: ${cBC44FF};
`;
